module.exports = __webpack_public_path__ + "static/media/full-screen-image-3.ef9c8d65.jpg";